import { db } from '../firebase/config';
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  serverTimestamp,
  orderBy,
  limit,
  doc,
  getDoc,
  setDoc
} from 'firebase/firestore';

const COLLECTION = 'assessments';
const LOCKS = 'assessmentLocks';
const UNLOCK_LOGS = 'assessmentUnlockLogs';

export async function saveAssessmentResult(userId, score, passed, details = {}) {
  await addDoc(collection(db, COLLECTION), {
    userId,
    score,
    passed,
    details,
    createdAt: serverTimestamp()
  });
  return true;
}

export async function getLatestAssessment(userId) {
  try {
    const q = query(
      collection(db, COLLECTION),
      where('userId', '==', userId),
      orderBy('createdAt', 'desc'),
      limit(1)
    );
    const snap = await getDocs(q);
    if (snap.empty) return null;
    const d = snap.docs[0];
    return { id: d.id, ...d.data() };
  } catch (e) {
    const q = query(
      collection(db, COLLECTION),
      where('userId', '==', userId)
    );
    const snap = await getDocs(q);
    if (snap.empty) return null;
    const all = snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => {
        const ta = a.createdAt?.toMillis ? a.createdAt.toMillis() : 0;
        const tb = b.createdAt?.toMillis ? b.createdAt.toMillis() : 0;
        return tb - ta;
      });
    return all[0] || null;
  }
}

export async function getAssessmentResultsForUser(userId, limitCount = 20) {
  try {
    const q = query(
      collection(db, COLLECTION),
      where('userId', '==', userId),
      orderBy('createdAt', 'desc'),
      limit(limitCount)
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (e) {
    const q2 = query(collection(db, COLLECTION), where('userId', '==', userId));
    const snap2 = await getDocs(q2);
    return snap2.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => {
      const ta = a.createdAt?.toMillis ? a.createdAt.toMillis() : 0;
      const tb = b.createdAt?.toMillis ? b.createdAt.toMillis() : 0;
      return tb - ta;
    }).slice(0, limitCount);
  }
}

export async function getAssessmentLock(userId) {
  const ref = doc(db, LOCKS, userId);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function lockAssessmentForUser(userId, meta = {}) {
  // Users can create their own lock; admins can also call this
  await setDoc(doc(db, LOCKS, userId), {
    userId,
    locked: true,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    reason: meta.reason || 'submitted',
    lockedBy: meta.lockedBy || userId
  }, { merge: true });
}

export async function unlockAssessmentForUser(userId, adminId, reason = 'admin_unlock') {
  await setDoc(doc(db, LOCKS, userId), {
    userId,
    locked: false,
    updatedAt: serverTimestamp(),
    unlockedBy: adminId,
    unlockReason: reason
  }, { merge: true });

  await addDoc(collection(db, UNLOCK_LOGS), {
    userId,
    unlockedBy: adminId,
    reason,
    createdAt: serverTimestamp()
  });
}

export default {
  saveAssessmentResult,
  getLatestAssessment,
  getAssessmentResultsForUser,
  getAssessmentLock,
  lockAssessmentForUser,
  unlockAssessmentForUser
};
